import axios from 'axios';
import { baseUrl } from "../common/siteSettings";
import heyapi from "../middleware/axiosInstance";

export const getEmployerPost = async (id,state, token) => {
    console.log(id)
    try {
        const response = await heyapi.get(`/admin/employer/posts?empid=${id}&state=${state}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        console.log(response.data)
        return response.data;
    }
    catch (err) {
        console.log(err);
    }
}

export const getAllPosts = async (state, token) => {
    console.log(state)
    try {
        const response = await heyapi.get(`/admin/posts?state=${state}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        console.log(response.data)
        return response.data;
    }
    catch (err) {
        console.log(err);
    }
}

export const getAllApplications = async (token) => {
    try {
        const response = await heyapi.get(`/admin/applications`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        console.log(response)
        return response;
    }
    catch (err) {
        console.log(err);
    }
}


export const deletePost = async (postid, token) => {
    try {
        const response = await heyapi.delete(`/admin/post/${postid}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        console.log(response)
        return response;
    }
    catch (err) {
        console.log(err);
    }
}

export const updatePostState = async (postid, state, token, reason) => {
    try {
        const data = {
            postid: postid, 
            status: state, 
            reason: reason
        }
        const response = await heyapi.patch(`/admin/post/updatestate`, 
            data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        //console.log(response.data)
        return response.data;
    }
    catch (err) {
        console.log(err);
    }
}


export const updateApplicationState = async (appid, state, token) => {
    try {
        const data = {
            id: appid, 
            state: state
        }
        const response = await heyapi.patch(`/admin/post/application/state`, 
            data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        //console.log(response.data)
        return response;
    }
    catch (err) {
        console.log(err);
    }
}

export const sharePostOnLinkedIn = async (postid, token) => {
    try {
        const data = {
            postid: postid
        }
        const response = await heyapi.post(`/admin/post/share/linkedin`, data , {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            
        });
        return response;
    }   
    catch (err) {
        console.log(err);
    }
}
